import { Button } from '@/components/ui/button';
import { useState } from 'react';

export const PortfolioFilters = ({ onFilter }: { onFilter: (filters: string[]) => void }) => {
  const categories = ["All", "Web", "Mobile", "AI", "Blockchain", "SaaS", 'E-Commerce', 'Finance', 'Healthcare'];
  const [activeFilters, setActiveFilters] = useState<string[]>(["All"]);

  const handleFilter = (category: string) => {
    let newFilters = [...activeFilters];
    
    if (category === "All") {
      newFilters = ["All"];
    } else {
      if (newFilters.includes("All")) {
        newFilters = newFilters.filter(f => f !== "All");
      }
      
      if (newFilters.includes(category)) {
        newFilters = newFilters.filter(f => f !== category);
        if (newFilters.length === 0) newFilters = ["All"];
      } else {
        newFilters.push(category);
      }
    }
    
    setActiveFilters(newFilters);
    onFilter(newFilters.includes("All") ? [] : newFilters);
  };

  return (
    <div className="flex flex-wrap gap-2 mb-8 bg-gray-900/50 backdrop-blur-sm p-4 rounded-lg border border-gray-700">
      <p className="w-full text-sm text-gray-400 mb-2">Filter by category:</p>
      {categories.map(category => (
        <Button
          key={category}
          variant={activeFilters.includes(category) ? "default" : "outline"}
          className={`rounded-full px-4 py-2 transition-all ${activeFilters.includes(category) 
            ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg" 
            : "bg-transparent border-gray-300 hover:bg-gradient-to-r hover:from-blue-500/20 hover:to-purple-600/20 hover:border-transparent"}`}
          onClick={() => handleFilter(category)}
        >
          {category}
        </Button>
      ))}
    </div>
  );
};
